// @ts-strict-ignore
import { Injectable } from '@angular/core';


@Injectable()
export class LMListFilterPersistenceService {

  private filterIds = [];

  public getUniqueFilterId(prefix: string): string {
    const id = Math.round(Math.random() * 99999 | 0).toString();
    const filterId = `${prefix}-${id}`;

    if (this.filterIds.includes(filterId)) {
      this.getUniqueFilterId(prefix);
    }

    this.filterIds.push(filterId);
    return filterId;
  }


  getFilterItem(key: string): string {
    lscache.setBucket('filterPreviewQuery');
    lscache.flushExpired();
    const cache = lscache.get(key);
    return cache;
  }

  /**
   * Save to local storage.
   * @param key - any unique string value
   * @param filter - any lpl filter string
   */
  setFilterItem(key: string, filter: any, ): void {
    lscache.setBucket('filterPreviewQuery');
    lscache.flushExpired();
    //set expiry to 8 hours
    lscache.set(key, filter, 480);
  }
}
